<template>
    <div>
        <div>
            <v-menu
                bottom
                right
                offset-y
                :internal-activator="true"
                v-model="openMenu"
                content-class="no-contain overflow-visible"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn style="padding: 0px 25px !important; margin-right: 10px;"
                         color="primary" dark v-on="on">
                    <span>Tìm kiếm</span>
                    <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-card
                    width="400px"
                    outlined
                    class="ma-0"
                >
                  <v-row class="px-5 py-5 mt-3">
                    <v-col
                        class="py-0"
                        cols="12">
                      <v-text-field
                          v-model="filterForm.keyword"
                          placeholder="Họ và tên, Email..."
                          label="Tìm kiếm theo tên hoặc email"
                          clearable
                          @keyup.enter="searchUser"
                      />
                    </v-col>
<!--                    <v-col-->
<!--                        class="py-0"-->
<!--                        cols="12">-->
<!--                      <v-autocomplete-->
<!--                          v-model="filterForm.departmentId"-->
<!--                          :items="departments"-->
<!--                          item-text="name"-->
<!--                          item-value="id"-->
<!--                          label="Tìm kiếm theo phòng ban"-->
<!--                          placeholder="Phòng ban"-->
<!--                          color="primary"-->
<!--                          clearable-->
<!--                      />-->
<!--                    </v-col>-->
<!--                    <v-col-->
<!--                        class="py-0"-->
<!--                        cols="12">-->
<!--                      <v-autocomplete-->
<!--                          v-model="filterForm.position"-->
<!--                          :items="userPositionOptions"-->
<!--                          item-text="text"-->
<!--                          item-value="value"-->
<!--                          label="Tìm kiếm theo chức danh"-->
<!--                          placeholder="Chức danh"-->
<!--                          color="primary"-->
<!--                          clearable-->
<!--                      />-->
<!--                    </v-col>-->
                    <v-col cols="12" class="py-0">
                      <validation-provider v-slot="{ errors }"
                                           name="Call center">
                        <v-autocomplete
                            v-model="filterForm.callcenterId"
                            :items="callCenters"
                            :error-messages="errors"
                            item-text="name"
                            item-value="id"
                            label="Call center *"
                            color="primary"
                            eager
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" class="py-0">
                      <validation-provider
                          v-slot="{ errors }"
                          class="mb-2"
                          :rules="{
                            max: 10,
                            regex: regex.isNumber
                          }"
                          name="Máy lẻ">
                        <v-text-field
                            v-model.trim="filterForm.ext"
                            label="Máy lẻ"
                            :error-messages="errors"
                            color="primary"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" class="py-0">
                      <validation-provider
                          :rules="{}"
                          v-slot="{ errors }"
                          name="Nhóm quyền">
                        <v-autocomplete
                            v-model="filterForm.roleIds"
                            :items="groupPermissionList"
                            :error-messages="errors"
                            item-text="name"
                            item-value="id"
                            label="Nhóm quyền"
                            color="primary"
                            multiple
                            clearable
                            @change="changeGroupPermissionList"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <div class="text-center mb-4">
                    <v-btn
                        class="primary mx-0"
                        @click="searchUser"
                    >
                      <v-icon>mdi-magnify</v-icon>Tìm kiếm
                    </v-btn>
                  </div>
                </v-card>
            </v-menu>
        </div>
    </div>
</template>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory'
import { userPositionOptions, contactSourceStatusOptions, regex } from '../../../helpers/constants'
const DepartmentRepository = RepositoryFactory.get('department')
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      default: () => ({}),
    },
    departments: {
      default: () => ([]),
    },
  },
  data () {
    return {
      openMenu: false,
      user: {},
      userPositionOptions,
      contactSourceStatusOptions,
      callCenters: [
        {
          id: '',
          name: 'Không chọn'
        },
        {
          id: 1,
          name: 'ePacific'
        },
        {
          id: 2,
          name: 'CareSoft'
        },
        {
          id: 3,
          name: 'Minh Phúc'
        },
        {
          id: 4,
          name: 'ODS'
        },
        // {
        //   id: 5,
        //   name: 'OMICALL'
        // },
        {
          id: 6,
          name: 'SUBIZ'
        },
      ],
      regex,
      groupPermissionList: []
    }
  },
  created() {
    Bus.$on('group-permission-list', item => {
      this.groupPermissionList = _.cloneDeep(item).map(item => {
        return {
          disabled: false,
          ...item
        }
      });
      this.groupPermissionList.unshift({
        id: -1,
        name: "Trống nhóm quyền",
        disabled: false
      })
    })
  },
  beforeDestroy() {
    Bus.$off('group-permission-list')
  },
  methods: {
    searchUser () {
      this.openMenu = false
      Bus.$emit('user-list-filter', this.filterForm)
    },
    changeGroupPermissionList () {
      let disabled = false;
      this.groupPermissionList = this.groupPermissionList.map(item => {
        if (this.filterForm.roleIds && this.filterForm.roleIds.length) {
          if (this.filterForm.roleIds.includes(-1)) {
            disabled = item.id == -1 ? false : true;
          } else {
            disabled = item.id == -1 ? true : false;
          }
        }
        return {
          ...item,
          disabled
        }
      });
    }
  },
}
</script>

<style scoped>
.v-text-field {
  margin-top: 0 !important;
}
</style>
